<div class="container-fluid px-4 mt-4 mb-5">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-user-tie me-2"></i>
            Gestión de Visitantes
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso/dependencias/gestion">Dependencia</a></li>
                <li class="breadcrumb-item active">Visitantes</li>
            </ol>
        </nav>
    </div>

    <div class="row">
        <div class="col-xl-12 col-md-12">
            <div class="card h-100">
                <div class="card-header cp-list-header">
                    <span class="cp-list-title">Listado de Visitantes</span>
                    <div class="btn-group btn-group-sm" role="group" *ngIf="level==99 || level==1">
                        <button class="btn btn-warning" (click)="openModal(addFile,'sm')">
                            <i class="fa-solid fa-file-arrow-up me-1"></i> Importar
                        </button>
                        <button class="btn btn-primary" (click)="openModal(add)">
                            <i class="fa-solid fa-circle-plus me-1"></i> Nuevo
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Filter Panel -->
                    <div class="cp-filter-panel" [formGroup]="form">
                        <div class="row">
                            <div style="flex: 1 1 300px;">
                                <label class="form-label">Buscar Visitante</label>
                                <app-toolbar-search [placeholder]="'Nombre o RUT'" [hideFilter]="true" (onEmptyInput)="clean()" (onSearch)="search($event)"/>
                            </div>
                            <div style="flex: 0 1 160px;">
                                <label class="form-label">Estado</label>
                                <select class="form-select" formControlName="state_id" (change)="filterChange()">
                                    <option value="">Todos</option>
                                    <option value="1">Autorizado</option>
                                    <option value="0">No autorizado</option>
                                </select>
                            </div>
                            <div style="flex: 0 1 150px;">
                                <label class="form-label">Desde</label>
                                <input type="date" class="form-control" formControlName="start" (change)="filterChange()">
                            </div>
                            <div style="flex: 0 1 150px;">
                                <label class="form-label">Hasta</label>
                                <input type="date" class="form-control" formControlName="end" (change)="filterChange()">
                            </div>
                            <div style="flex: 0 1 120px;">
                                <button class="btn btn-outline-secondary w-100" type="button" (click)="clean()">
                                    <i class="fa-solid fa-rotate-left me-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>

                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table cp-table">
                            <thead>
                                <tr>
                                    <th><span>AUTORIZACIÓN</span></th>
                                    <th><span>NOMBRE</span></th>
                                    <th><span>RUT</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of items">
                                    <td style="max-width: 200px;">
                                        <span class="badge" [ngClass]="item.state_id==1 ? 'bg-primary' : 'bg-danger'">
                                            {{(item.state_id==1)?"Autorizado":"No Autorizado"}}</span>
                                        {{item.date_ing | date}}
                                    </td>
                                    <td>
                                        <span>{{item.name | uppercase}}</span> &nbsp;
                                        <span>{{item.lastname | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span>{{item.rut | uppercase}}</span>
                                    </td>
                                    <td>
                                        <div class="btn-group" role="group" aria-label="Basic mixed styles example" *ngIf="level==99 || level==1">
                                            <button type="button" class="btn   text-warning"
                                                (click)="openEdit(item,edit)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                            <button  type="button" class="btn  text-danger"
                                                (click)="openDelete(item,remove)">
                                                <i class="fa-solid fa-trash"></i>

                                            </button>
                                        </div>

                                    </td>
                                </tr>
                                <tr *ngIf="!items">
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron registros</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #remove let-c="close" let-d="dismiss">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Eliminar registro</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>¿Esta seguro que desea eliminar este registro?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">No</button>
        <button type="button" ngbAutofocus class="btn btn-danger" (click)="delete()">Si</button>
    </div>

</ng-template>

<ng-template #add let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-visitor [storesId]="storesId" (success)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>


<ng-template #edit let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-edit-visitor [visitors]="selected" (success)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<ng-template #addFile let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-upload-file endPoint="3" (onSuccess)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>